import React from 'react'

function Processing() {

    return (
        <>
            <div className='row'>
                <div className='col-12 text-center'>
                    <h4 style={{ fontWeight: 600 }}>Processing</h4>
                </div>
            </div>
            <div className='row'>
                <div className='col-12 text-center'>
                    <div className="progress-container">
                        <div className="progress-bar">
                            <div className="progress-bar-value"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className='col-12 col-lg-8 offset-lg-2 text-center mt-5 mb-5'>
                    <p style={{ color: '#6c757d' }}>
                        The process of reviewing your account may take a few minutes to complete. Once the review is finished, we will display the decision. If you would prefer not to wait, an email with the final decision will be sent to you. Thank you for your patience.
                    </p>
                </div>
            </div>
        </>
    )
}

export default Processing
